module.exports = __webpack_public_path__ + "img/wishartr.bae2cb75.jpg";